import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { Permissions } from '@utils/constants/permissions';
import { useQuery } from 'react-query';

import { autoTaskConstants, autoTaskModels } from '..';

export const useAutoTaskConfigBuilding = (props: { enabled?: boolean } = { enabled: true }) => {
  const permissions = useAppSelector(state => state?.userReducer?.user?.role?.permissions);

  const isAutoTask = permissions?.includes(Permissions.PERMISSION_SETTINGS_AUTO_TASK);
  const data = useQuery<Record<string, autoTaskModels.IAutoTaskBuilding[]>>({
    queryKey: [autoTaskConstants.queryKeys.AUTO_TASK_CONFIG_BUILDING],
    queryFn: async () => {
      const res = await $api.get('/v1/auto-task-setting/building');

      return res?.data?.data;
    },
    enabled: props?.enabled && isAutoTask
  });

  const buildingArray = Object.entries(data?.data || {}).map(([k, v]) => ({
    label: k,
    children: v?.map(item => ({
      label: item?.name,
      value: item?.id
    }))
  }));

  return { ...data, buildingArray };
};
